import React, { useMemo, useEffect, useCallback } from 'react';
import styles from './IntroOutroEditor.module.scss';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';
import { CustomButton } from '../Button/Button';
import { useIntroOutroContext } from '../../context/IntroOutroContext';
import IntroOutroItem from './IntroOutroItem';

const noIntroOutro = {
  id: '',
  video: null,
  thumbnail: null,
  duration: null,
}

const IntroOutroEditor = ({ handleIntroOutro, miniSidebar, closeFeatures }) => {
  const { selectedIntroOutro, initialIntroOutro, toggleIntroOutroOpened, introOutroConfig } = useIntroOutroContext();
  const isNoChanges = useMemo(
    () => selectedIntroOutro.intro?.id === initialIntroOutro.intro?.id && selectedIntroOutro.outro?.id === initialIntroOutro.outro?.id,
    [selectedIntroOutro, initialIntroOutro]
  );

  const { t } = useTranslation();

  const handleSaveChanges = useCallback(() => {
    toggleIntroOutroOpened();
    handleIntroOutro({
      introOutro: structuredClone(selectedIntroOutro),
      registerAction: true,
    });
  }, [selectedIntroOutro]);

  useEffect(() => {
    if (miniSidebar || closeFeatures) {
      handleClose();
    }
  }, [miniSidebar, closeFeatures]);

  const handleClose = () => {
    toggleIntroOutroOpened();
    handleIntroOutro({ introOutro: structuredClone(initialIntroOutro) });
  };

  const handleChoose = (introOutro, isSelected) => {
    if (isSelected) {
      const resetIntroOutro = {
        ...(introOutro.hasOwnProperty('intro') ? {
          intro: structuredClone(noIntroOutro)
        } : {}),
        ...(introOutro.hasOwnProperty('outro') ? {
          outro: structuredClone(noIntroOutro)
        } : {}),
      };
      handleIntroOutro({ introOutro: resetIntroOutro });
      return;
    }

    handleIntroOutro({ introOutro });
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.contentContainer}>
        <div className={styles.closeContainer}>
          <span>{t('my_video.tools.intro_outro.title')}</span>
          <CloseButton onClose={handleClose} />
        </div>
        <div className={styles.introOutroContainer}>
          <IntroOutroItem key={'no-intro-outro'} id={'no-intro-outro'} handleChoose={handleChoose} intro={null} outro={null} allowCheckboxOnEmpty={true} />

          {introOutroConfig?.map(({ id, name, intro, outro }) => (
            <IntroOutroItem key={id} id={id} handleChoose={handleChoose} name={name} intro={intro} outro={outro} />
          ))}
        </div>
      </div>
      <div className={styles.footer}>
        <CustomButton
          onClick={handleSaveChanges}
          disabled={isNoChanges}
          className={styles.saveBtn}
          label={t('general.save')}
          variant="primary"
        />
      </div>
    </div>
  );
};

export default IntroOutroEditor;
